import React from "react";
import styled from "styled-components";
import { experiences } from "../../data/constants";
import { VerticalTimeline } from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import ExperienceCard from "../cards/ExperienceCard";

const Container = styled.div`
  margin-top: 140px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  z-index: 1;
  align-items: center;
  padding: 0 20px;
`;

const Wrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  max-width: 1200px;
  gap: 8px;
`;

// Styles identiques à Skills.js
const Title = styled.div`
  font-size: 52px;
  text-align: center;
  font-weight: 600;
  margin-top: 20px;
  color: ${({ theme }) => theme.text_primary};
  
  @media (max-width: 768px) {
    margin-top: 12px;
    font-size: 32px;
  }
`;

const Desc = styled.div`
  font-size: 18px;
  text-align: center;
  font-weight: 600;
  color: ${({ theme }) => theme.text_secondary};
  margin-bottom: 40px;
  
  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const Experience = () => {
  if (!experiences || experiences.length === 0) {
    return (
      <Container id="experience">
        <Wrapper>
          <Title>Experience</Title>
          <Desc>My journey as a Full Stack and AI Developer, building innovative solutions across diverse projects and companies.</Desc>
        </Wrapper>
      </Container>
    );
  }

  return (
    <Container id="experience">
      <Wrapper>
        <Title>Experience</Title>
        <Desc>My journey as a Full Stack and AI Developer, building innovative solutions across diverse projects and companies.</Desc>

        <VerticalTimeline
          layout="1-column"
          lineColor="rgba(196, 196, 196, 1)"
        >
          {experiences.map((experience, index) => (
            <ExperienceCard
              key={`experience-${index}`}
              experience={experience}
              index={index}
            />
          ))}
        </VerticalTimeline>
      </Wrapper>
    </Container>
  );
};

export default Experience;